<template>
  <ModalFullscreen
    modal-id="modal-id-search"
    background-color="bg-primary-450"
    padding-class="px-0 pt-2"
  >
    <div class="text-primary flex-fill flex">
      <Search
        type="mobileSearchModal"
        :items="[products, categories]"
        @search-changed="searchChanged"
        @value-changed="searchValueChanged"
        @enter-pressed="goToSearchView"
        @close-btn-clicked="closeModal"
      >
        <template #items="itemsProps">
          <div class="row m-O border-bottom border-2 border-primary sticky zindex-11 top-0">
            <button
              type="button"
              class="col-6 btn btn-beige rounded-0 shadow-none"
              :class="{ focus: toggleTab }"
              @click="toggleTab = true"
            >
              {{ t('ready_mixes_title') }}
                  &nbsp;
              <strong class="text-xs">({{ itemsProps.items[0].length }})</strong>
            </button>
            <button
              type="button"
              class="col-6 btn btn-beige rounded-0 shadow-none"
              :class="{ focus: !toggleTab }"
              @click="toggleTab = false"
            >
              {{ t('categories') }}
                  &nbsp;
              <strong class="text-xs">({{ itemsProps.items[1].length }})</strong>
            </button>
          </div>
          <div
            v-if="toggleTab"
            class="flex-fill flex flex-col w-100"
          >
            <div
              v-if="itemsProps.items[0].length > 0 && isLoaded"
              class="bg-white mx-n2"
            >
              <ul class="list-unstyled m-0 pt-2 pb-5 justify-center row search-results-modal">
                <li
                  v-for="item in itemsProps.items[0]"
                  :key="item.id"
                  class="flex py-2 px-1 relative col-10 sm:col-7"
                  :class="{ 'item-show': itemsProps.items[0].length > 0 }"
                >
                  <div class="row flex-grow-1 items-center item relative">
                    <div class="col-4 md:col-2 px-1">
                      <div
                        v-if="item.images.length > 0"
                        class="mb-0 flex-grow-1"
                      >
                        <RemoteResponsiveImage
                          :product-image-data="item.images[0]?.data"
                          img-class="modal_mobile_search-img image-cover"
                          :alt="item.name"
                          sizes="25vw"
                        />
                      </div>
                    </div>
                    <div class="md:col-10 col-8 px-1">
                      <router-link
                        class="block p-1 text-sm flex-grow-1 leading-sm stretched-link zindex-1"
                        :to="{ name: 'productPath', params: { permalink: item.permalink } }"
                      >
                        <span class="block">{{ item.name }}</span>
                        <strong class="text-sm">
                          <span v-if="item.quantityDiscounts">
                            {{
                              discountPriceFormatter(
                                showFromLabel(item.quantityDiscounts, item.plusClubPrice) ? t('from') : '',
                                item.plusClubPrice,
                                getCurrentCustomer?.inPlusClub,
                                item.quantityDiscounts[0].price,
                                item.quantityDiscounts[item.quantityDiscounts.length - 1].price,
                                item.currency,
                              )
                            }}
                          </span>
                          <span v-else>{{ numberToCurrency(item.price, item.currency) }}</span>
                        </strong>
                      </router-link>
                      <div class="relative float-right mt-n2 zindex-2">
                        <AddToCartButton
                          v-if="!item.isIngredient && item.state === 'available'"
                          :icon-button-only="true"
                          :product="item"
                          gtm-source="navbar-products-search"
                        />
                        <router-link
                          v-else
                          v-close-popper
                          :to="{ name: 'productPath', params: { permalink: item.permalink } }"
                          type="button"
                          class="btn btn-warning p-2 stretched-link rounded-circle"
                          data-toggle="product-detail-modal"
                          aria-label="product info"
                        >
                          <i class="mi-info icon-14" />
                        </router-link>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <button
                class="btn  btn-primary px-5 md:px-3 xl:px-5 font-medium rounded-0 sticky zindex-11  bottom-0 w-100"
                type="button"
                @click="goToSearchView"
              >
                {{ t('show_all_results') }}
              </button>
            </div>
            <div
              v-else-if="searchText && isLoaded"
              class="bg-white pt-5 pb-5 mx-n2 flex-fill row justify-center pl-3 pr-3"
            >
              <div class="container">
                <span class="text-primary opacity-20 pb-4 block text-center">
                  <i class="mi-search-err icon-40" />
                </span>
                <h4 class="text-primary mb-5 opacity-30 text-center block">
                  {{ t('we_do_not_know_this_beak') }}
                </h4>
                <hr>
                <h4 class="text-primary mb-2 mt-5 text-center block">
                  {{ t('bestsellers') }}
                </h4>
                <Carousel
                  v-if="crossSell?.length > 0"
                  :slides="crossSell"
                  class="col-12"
                />
              </div>
            </div>
            <div
              v-else-if="itemsProps.items[0].length === 0 && !searchText"
              class="bg-white pt-5 pb-5 mx-n2 flex-fill flex-col justify-center"
            >
              <div class="container">
                <span class="text-primary opacity-20 pb-4 block text-center">
                  <i class="mi-search icon-40" />
                </span>
                <h4 class="text-primary mb-5 opacity-30 text-center block">
                  {{ t('search_text') }}
                </h4>
                <hr>
                <h4 class="text-primary mb-2 mt-5 text-center block">
                  {{ t('bestsellers') }}
                </h4>
                <Carousel
                  v-if="crossSell?.length > 0"
                  :slides="crossSell"
                  class="col-12"
                />
              </div>
            </div>
            <div
              v-else
              class="bg-white pt-5 pb-5 mx-n2 flex-fill row justify-center"
            >
              <BaseLoading :style="{ minHeight: '30vh' }" />
            </div>
          </div>
          <div
            v-else
            class="flex-fill flex flex-col w-100"
          >
            <ul
              v-if="itemsProps.items[1].length > 0 && isLoaded"
              class="list-unstyled m-0 bg-white pt-2 pb-5 mx-n2 justify-center row search-results-modal"
            >
              <li
                v-for="category in itemsProps.items[1]"
                :key="category.systemName"
                class="flex py-2 px-1 relative col-10 sm:col-7"
              >
                <div class="row flex-grow-1 items-center item relative">
                  <div class="col-4 lg:col-2 px-1">
                    <div class="embed-responsive embed-responsive-4by3 mb-0 rounded-sm">
                      <RemoteImage
                        :src="`https://img.mix.it/general_assets/categories/${category.image}`"
                        img-class="embed-responsive-item image-contain"
                        :alt="category.title"
                      />
                    </div>
                  </div>
                  <div class="col-8 lg:col-10 px-1">
                    <router-link
                      v-close-popper
                      :to="{ name: 'productsPath', params: { permalink: category.permalink } }"
                      class="block stretched-link font-medium underline-hover leading-sm"
                    >
                      {{ category.title }}
                    </router-link>
                  </div>
                </div>
              </li>
            </ul>
            <div
              v-else-if="searchText && isLoaded"
              class="bg-white pt-5 pb-5 mx-n2 flex-fill row justify-center pl-3 pr-3"
            >
              <div class="container">
                <span class="text-primary opacity-20 pb-4 block text-center">
                  <i class="mi-search-err icon-40" />
                </span>
                <h4 class="text-primary mb-5 opacity-30 text-center block">
                  {{ t('we_do_not_know_this_beak') }}
                </h4>
                <hr>
                <h4 class="text-primary mb-2 mt-5 text-center block">
                  {{ t('bestsellers') }}
                </h4>
                <Carousel
                  v-if="crossSell?.length > 0"
                  :slides="crossSell"
                  class="col-12"
                />
              </div>
            </div>
            <div
              v-else-if="itemsProps.items[1].length === 0 && !searchText"
              class="bg-white pt-5 pb-5 mx-n2 flex-fill row justify-center"
            >
              <span class="text-primary opacity-20 mt-5 pb-4 block text-center">
                <i class="mi-search icon-180" />
              </span>
              <h4 class="text-primary mb-0 mt-5 opacity-30 text-center block">
                {{ t('search_text') }}
              </h4>
            </div>
            <div
              v-else
              class="bg-white pt-5 pb-5 mx-n2 flex-fill row justify-center"
            >
              <BaseLoading :style="{ minHeight: '30vh' }" />
            </div>
          </div>
        </template>
      </Search>
    </div>
  </ModalFullscreen>
  <BaseModal
    :title="t('watchdog_title')"
    modal-id="modal-watchdog"
  >
    <ModalWatchdog />
  </BaseModal>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import RetailApiV2 from '@/api/retailApi/RetailApiV2'
import AddToCartButton from '@/components/buttons/ButtonAddToCartButton.vue'
import BaseLoading from '@/components/general/BaseLoading.vue'
import BaseModal from '@/components/general/BaseModal.vue'
import ModalFullscreen from '@/components/general/BaseModalFullscreen.vue'
import RemoteImage from '@/components/general/BaseRemoteImage.vue'
import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'
import Search from '@/components/general/BaseSearch.vue'
import ModalWatchdog from '@/components/modals/ModalWatchdog.vue'
import { discountPriceFormatter } from '@/mixins/discountPriceFormatter'
import { numberToCurrency } from '@/mixins/numberToCurrency'
import { useAppStore } from '@/stores/AppStore'
import { useModalStore } from '@/stores/ModalStore'
import Carousel from '@/components/carousel/Carousel.vue'
import { useProductStore } from '@/stores/ProductStore'

const appStore = useAppStore()
const { getCurrentCustomer } = storeToRefs(appStore)

const { t } = useI18n()

const router = useRouter()
const products = ref([])
const categories = ref([])
const searchText = ref()
const toggleTab = ref(true)
const isLoaded = ref(false)

const productStore = useProductStore()
const { closeModal } = useModalStore()
const searchValueChanged = (value) => {
  searchText.value = value
}
const searchChanged = async (value) => {
  searchText.value = value
  isLoaded.value = false
  if (value.length > 0) {
    const { data } = await RetailApiV2.get(`search?q=${value}&limit=30&variant=modest`)
    products.value = data.products
    categories.value = data.categories
    isLoaded.value = true
  } else {
    products.value = []
    categories.value = []
    isLoaded.value = false
  }
}
const goToSearchView = () => {
  const url = router.resolve({ name: 'searchPath', params: { search: searchText.value } })
  window.location.href = url.href
}

// Defines if "From [some price]" label should be visible.
const showFromLabel = (quantityDiscounts, plusClubPrice) => {
  return quantityDiscounts && (!plusClubPrice || !getCurrentCustomer.value?.inPlusClub)
}

const crossSell = ref()

const loadCrossSell = async () => {
  crossSell.value = await productStore.loadCrossSell('quantity=6&kind=homepage_favorite_cross_sell')
}

loadCrossSell()
</script>

<style lang="scss">
.modal_mobile_search-img {
  width: 88px;
  height: 66px;
}
</style>

<i18n>
  {
    "cs": {
    "bestsellers": "Bestsellery",
    "categories": "Kategorie",
    "from": "Od",
    "ready_mixes_title": "Produkty",
    "search_text": "Napište, jaké dobroty hledáte",
    "show_all_results": "Zobrazit všechny výsledky",
    "watchdog_title": "Chcete si počkat?",
    "we_do_not_know_this_beak": "Bohužel tohle zobání jsme nenašli. Zkuste kouknout po jiném."
},
    "sk": {
    "bestsellers": "Bestsellery",
    "categories": "Kategórie",
    "from": "Od",
    "ready_mixes_title": "Produkty",
    "search_text": "Napíšte, aké dobroty hľadáte",
    "show_all_results": "Zobraziť všetky výsledky",
    "watchdog_title": "Chcete si počkať?",
    "we_do_not_know_this_beak": "Bohužiaľ toto zobkanie sme nenašli. Skúste sa pozrieť po inom."
},
    "pl": {
    "bestsellers": "Bestsellery",
    "categories": "Kategorie",
    "from": "Od",
    "ready_mixes_title": "Produkty",
    "search_text": "Napisz, jakich przekąsek szukasz",
    "show_all_results": "Pokaż wszystkie wyniki",
    "watchdog_title": "Chcesz poczekać?",
    "we_do_not_know_this_beak": "Niestety nie znaleźliśmy tego smakołyku. Spróbuj znaleźć coś innego."
},
    "hu": {
    "bestsellers": "Bestsellerek",
    "categories": "Kategóriák",
    "from": "Ft-tól",
    "ready_mixes_title": "Termékek",
    "search_text": "Írd le, milyen finomságokat keresel",
    "show_all_results": "Minden eredmény megtekintése",
    "watchdog_title": "Szeretnél várni?",
    "we_do_not_know_this_beak": "Sajnos ezt a falatot nem találtuk. Próbálj meg másikat keresni."
},
    "de": {
    "bestsellers": "Bestseller",
    "categories": "Kategorie",
    "from": "Von",
    "ready_mixes_title": "Produkte",
    "search_text": "Schreib uns, welche Leckereien du suchst",
    "show_all_results": "Alle Ergebnisse anzeigen",
    "watchdog_title": "Möchtest du warten?",
    "we_do_not_know_this_beak": "Leider haben wir diesen Snack nicht gefunden. Versuche, einen anderen zu finden."
},
    "at": {
    "bestsellers": "Bestseller",
    "categories": "Kategorie",
    "from": "Von",
    "ready_mixes_title": "Produkte",
    "search_text": "Schreib uns, welche Leckereien du suchst",
    "show_all_results": "Alle Ergebnisse anzeigen",
    "watchdog_title": "Möchtest du warten?",
    "we_do_not_know_this_beak": "Leider haben wir diesen Snack nicht gefunden. Versuche, einen anderen zu finden."
},
    "ro": {
    "bestsellers": "Cele mai vândute",
    "categories": "Categorii",
    "from": "De la",
    "ready_mixes_title": "Produse",
    "search_text": "Scrieți ce bunătăți căutați",
    "show_all_results": "Vizualizează toate rezultatele",
    "watchdog_title": "Dorești să aștepți?",
    "we_do_not_know_this_beak": "Din păcate, nu am găsit această bunătate. Încearcă să cauți alta."
},
    "fr": {
    "bestsellers": "Best-sellers",
    "categories": "Catégories",
    "from": "À partir de",
    "ready_mixes_title": "Produits",
    "search_text": "Dites-nous quelle gourmandise vous cherchez",
    "show_all_results": "Afficher tous les résultats",
    "watchdog_title": "Voulez-vous patienter ?",
    "we_do_not_know_this_beak": "Malheureusement, nous n’avons pas trouvé ce produit. Essayez d’en chercher un autre !"
},
    "it": {
    "bestsellers": "Bestseller",
    "categories": "Categoria",
    "from": "Da",
    "ready_mixes_title": "Prodotti",
    "search_text": "Scrivi quali prelibatezze stai cercando",
    "show_all_results": "Mostra tutti i risultati",
    "watchdog_title": "Vuoi aspettare?",
    "we_do_not_know_this_beak": "Purtroppo non abbiamo trovato questo spuntino. Prova a cercarne un altro."
}
  }
</i18n>
